module.exports = __webpack_public_path__ + "e8971095df3c049b352916b434c01282.png";